<template>
  <div class="wrap-button">
    <v-menu
      v-if="
        ((isDownloadBtnVisible && !isLastClip && isNotEmpty) ||
          ((isClipUploader || isMtOrganizer || isWsOwner || isWsManager) && !isLastClip && isNotEmpty)) &&
        !isDisableDownload
      "
      v-model="expandMenu"
      offset-y
      top
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn plain v-bind="attrs" v-on="on" style="min-width: 35px">
          <span style="font-size: 16px; font-weight: 500" class="material-icons-round white--text" translate="no">
            {{ expandMenu ? 'close' : 'more_horiz' }}
          </span>
        </v-btn>
      </template>
      <div class="container-menu-comment" style="background-color: #1d292f; overflow: hidden">
        <v-row align="center" justify="center" dense>
          <v-col cols="12" v-if="isDownloadBtnVisible && !isLastClip">
            <v-tooltip
              v-if="!isLastClip"
              top
              color="#131b1e"
              :open-on-hover="isMobile ? false : true"
              :open-on-click="isMobile ? false : true"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  dark
                  block
                  color="#eee"
                  plain
                  v-show="isDownloadBtnVisible"
                  :disabled="isDownloadLoading"
                  @click="downloadClip"
                  class="btn-control"
                  elevation="0"
                  v-on="on"
                >
                  <v-progress-linear
                    v-if="downloadPercent > 0"
                    v-model="downloadPercent"
                    background-opacity="1"
                    background-color="#161d21"
                    style="position: absolute; height: 20px; border-radius: 5px"
                  ></v-progress-linear>
                  <span v-if="downloadPercent == 100" class="checkmark"></span>
                  <div
                    v-if="downloadPercent == 0"
                    class="d-flex"
                    style="align-items: center; font-size: 13px; font-weight: 400"
                  >
                    <span
                      class="material-icons-round white--text mr-1"
                      style="color: #ddd; font-size: 18px; font-weight: 400"
                      translate="no"
                    >
                      file_download
                    </span>
                    {{ $t('download') }}
                  </div>
                </v-btn>
              </template>
              <span>{{ $t('download') }}</span>
            </v-tooltip>
          </v-col>
          <v-col
            cols="12"
            v-if="
              isDownloadBtnVisible &&
              !isLastClip &&
              (isClipUploader || isMtOrganizer || isWsOwner || isWsManager) &&
              !isLastClip
            "
            style="padding: 0 !important"
          >
            <v-divider dark style="display: block"></v-divider>
          </v-col>
          <v-col cols="12" v-if="(isClipUploader || isMtOrganizer || isWsOwner || isWsManager) && !isLastClip">
            <div
              :class="
                $vuetify.breakpoint.width < 960
                  ? 'container-btn d-flex flex-nowrap'
                  : 'container-btn d-flex flex-nowrap mr-3'
              "
            >
              <clip-delete-dialog @expandMenu="setExpandMenu"></clip-delete-dialog>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-menu>
    <div
      class="container-btn d-flex flex-nowrap mr-2"
      v-if="this.totalWatchedUser && this.totalWatchedUser !== null && isNotEmpty"
      style="font-size: 14px; color: #96a7af"
    >
      <v-tooltip
        top
        color="#131b1e"
        v-if="!isLastClip"
        :open-on-hover="isMobile ? false : true"
        :open-on-click="isMobile ? false : true"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            v-show="isWatchedBtnVisible"
            @click="onWatchedUser"
            class="btn-control"
            elevation="0"
            v-on="on"
            :disabled="isDisableWatched"
          >
            <span class="material-icons-round" style="color: #ccc; font-size: 18px; cursor: pointer" translate="no">
              visibility
            </span>
            <div class="badge-watched">{{ totalWatchedUser.length }}</div>
          </v-btn>
        </template>
        <span>See who watched this clip(w)</span>
      </v-tooltip>
    </div>
    <div style="display: flex; justify-content: flex-start">
      <div class="container-btn d-flex flex-nowrap mr-2">
        <v-tooltip
          top
          color="#131b1e"
          :open-on-hover="isMobile ? false : true"
          :open-on-click="isMobile ? false : true"
        >
          <template v-slot:activator="{ on }">
            <v-btn ref="prevBtn" @click="$store.dispatch('beforeClip')" class="btn-control" elevation="0" v-on="on">
              <span class="material-icons-round" style="color: #ccc; font-size: 20px; cursor: pointer" translate="no">
                chevron_left
              </span>
            </v-btn>
          </template>
          <span>Previous Clip(shift+left)</span>
        </v-tooltip>
      </div>
      <div class="container-btn d-flex flex-nowrap mr-2">
        <v-tooltip
          top
          color="#131b1e"
          :open-on-hover="isMobile ? false : true"
          :open-on-click="isMobile ? false : true"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              ref="nextBtn"
              @click="$store.dispatch('nextClip')"
              class="btn-control"
              elevation="0"
              v-on="on"
              translate="no"
            >
              <span class="material-icons-round" style="color: #ccc; font-size: 20px; cursor: pointer">
                chevron_right
              </span>
            </v-btn>
          </template>
          <span>Next Clip(shift+right)</span>
        </v-tooltip>
      </div>
    </div>
    <watched-user-dialog
      v-if="watchedUserVisible"
      @close="watchedUserVisible = false"
      :watchedUser.sync="currentClip.watchedUser"
      :unWatchedUser.sync="unWatchedUser"
      :unWatchedOther.sync="unWatchedOther"
      :anonymousUser.sync="currentClip.anonymousUser"
      :watchedUserVisible.sync="watchedUserVisible"
    ></watched-user-dialog>
  </div>
</template>

<script>
import { getTargetList } from '@/services/meetingApi'
import { getFileDownload } from '@/services/api'
import { setClipUpdate } from '@/services/clipApi'
import watchedUserDialog from '@/views/modal/WatchedUserDialog'
import ClipDeleteDialog from '@/views/modal/ClipDeleteDialog.vue'
import { mapGetters, mapState } from 'vuex'
import Toast from '@/views/meeting/component/Toast'
import { isMobile } from '@/common/lib/strLib'
// import { download } from '@/services/api'

export default {
  name: 'DetailButton',
  components: {
    watchedUserDialog,
    ClipDeleteDialog,
  },
  props: ['sectionIndex', 'sectionClipIndex'],
  data() {
    return {
      clipNote: '',
      clipTitle: '',
      watchedUserVisible: false,
      isIncludeShare: location.pathname.includes('share'),
      isDownloadLoading: false,
      isRequestClipShowing: false,
      isWatchedBtnVisible: true,
      isDownloadBtnVisible: true,
      downloadPercent: 0,
      unWatchedUser: [],
      unWatchedOther: [],
      memberList: [],
      memberData: [],
      filteredMemberData: [],
      isLoading: false,
      expandMenu: false,
    }
  },
  created() {
    this.getMember()
  },
  mounted() {
    //초기에 바로 값을 반영하기 위해 mounteddp onClipChange
    this.onClipChange(this.currentClip)

    document.addEventListener('keydown', this.keyEvent)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.keyEvent)
  },
  methods: {
    async getMember() {
      if (Object.keys(this.userInfo).length === 0 || !this.userInfo.userId) return

      this.isLoading = true
      try {
        let ctx = this
        let userInfo

        let result = await getTargetList(this, this.mtInfo.mtId, this.userInfo.userId, false)
        this.memberList = result.mtTargetList
        if (this.memberList && this.memberList !== null) {
          userInfo = this.memberList.find((user) => user.userId === ctx.mtInfo.mtOrganizerUid)
          if (userInfo && userInfo !== null) this.memberList.splice(this.memberList.indexOf(userInfo), 1)
          this.memberList.unshift(userInfo)
        }
        this.setList()
      } catch (err) {
        console.log(err)
      } finally {
        this.isLoading = false
      }
    },
    setList() {
      this.memberData = []
      this.memberList.forEach((value) => {
        const member = {}
        member.userId = value.userId
        member.userDisplayName = value.userDisplayName
        member.userFullName = value.userFullName
        member.userPicture = value.userPicture
        member.userEmail = value.userEmail
        member.userStatus = value.userStatus
        this.memberData.push(member)
      })

      if (this.currentClip.customRecipientList) {
        this.currentClip.customRecipientList.forEach((value) => {
          const customRecipientListMember = {}
          if (value.userId) customRecipientListMember.userId = value.userId
          if (value.userDisplayName) customRecipientListMember.userDisplayName = value.userDisplayName
          if (value.userFullName) customRecipientListMember.userFullName = value.userFullName
          if (value.userPicture) customRecipientListMember.userPicture = value.userPicture
          if (value.userEmail) customRecipientListMember.userEmail = value.userEmail
          if (value.userStatus) customRecipientListMember.userStatus = value.userStatus
          this.memberData.push(customRecipientListMember)
        })
      }

      this.filteredMemberData = this.memberData.filter(
        (value, index, self) => index === self.findIndex((t) => t.userEmail === value.userEmail)
      )

      if (this.currentClip.watchedUser) {
        this.unWatchedUser = this.filteredMemberData.filter(
          (a) => !this.currentClip.watchedUser.map((b) => b.userEmail).includes(a.userEmail)
        )

        this.unWatchedOther = this.unWatchedUser.filter(function (e) {
          return !e.userId
        })

        this.unWatchedUser = this.unWatchedUser.filter(function (e) {
          return e.userId
        })
      }
    },
    setExpandMenu(val) {
      this.expandMenu = val
    },
    setButtonsStatus(downloadBtnStatus, watchedBtnStatus) {
      this.isDownloadBtnVisible = downloadBtnStatus
      this.isWatchedBtnVisible = watchedBtnStatus
    },
    onClipChange(currentClip) {
      let clipType = currentClip.clipType
      this.downloadPercent = 0

      if (clipType) {
        switch (clipType.toLowerCase()) {
          case 'text':
            this.setButtonsStatus(false, true)
            break
          case 'poll':
          case 'embed':
          case 'willfollowup':
          case 'followup':
            this.setButtonsStatus(false, false)
            break
          default:
            this.setButtonsStatus(true, true)
            break
        }
      }
    },
    keyEvent(e) {
      if (
        !(e.target instanceof HTMLTextAreaElement) &&
        !(e.target instanceof HTMLInputElement) &&
        e.target.contentEditable !== 'true'
      ) {
        if (!e.ctrlKey && !e.metaKey && e.keyCode === 39 && e.shiftKey) {
          this.$store.dispatch('nextClip')
          e.preventDefault()
        } else if (!e.ctrlKey && !e.metaKey && e.keyCode === 37 && e.shiftKey) {
          this.$store.dispatch('beforeClip')
          e.preventDefault()
        } else if (!e.ctrlKey && !e.metaKey && e.keyCode === 87) {
          this.onWatchedUser()
          e.preventDefault()
        }
      }
    },
    /**
     * Update Meeting Info
     * oldClip !== undefiend 인 경우는 자동으로 다음클립 넘어갔을 경우 재생시켜줄 때
     */
    async setClipUpdate() {
      if (this.editingClip !== undefined && this.editingClip !== null && this.isClipUploader) {
        // Blur 등 현재 상태에서 업데이트인 경우
        // if (this.editingClip.clipNote !== this.clipNote || this.editingClip.clipTitle === this.clipTitle) {
        let clipIndex = this.totalSectionList[this.sectionIndex].clipList.findIndex(
          (clip) => clip.clipId === this.editingClip.clipId
        )
        if (clipIndex >= 0) {
          this.totalSectionList[this.sectionIndex].clipList[clipIndex].clipNote = this.editingClip.clipNote
          this.totalSectionList[this.sectionIndex].clipList[clipIndex].clipTitle = this.editingClip.clipTitle
          try {
            await setClipUpdate(
              this,
              this.$store.getters.selectedWsInfo.wsId,
              this.mtInfo.mtId,
              this.editingClip.clipId,
              this.editingClip.clipNote,
              this.editingClip.clipTitle
            )
          } catch (error) {
            console.log(error)
          } finally {
            // await this.$store.dispatch('setIsLoading', false)
          }
        }
        // }
      }
    },
    calCreateAt(val) {
      // return this.$day.duration(this.$day().diff(val)).humanize() + ' ago '
      let value
      try {
        value = this.$day(val).format('ddd, MMM D, H:mmA')
      } catch (err) {
        console.log(err)
      }

      return value
    },
    onWatchedUser() {
      if (this.totalWatchedUser.length > 0) this.watchedUserVisible = true
    },
    async downloadClip() {
      this.downloadPercent = 0

      let getPercent = setInterval(() => {
        if (localStorage.getItem('downloadPercent'))
          this.downloadPercent = Number(localStorage.getItem('downloadPercent'))
      }, 100)
      try {
        this.isDownloadLoading = true
        let title =
          this.currentClip.clipTitle !== undefined &&
          this.currentClip.clipTitle !== null &&
          this.currentClip.clipTitle !== ''
            ? this.currentClip.clipTitle
            : 'unTitled'

        // let result = await getFileDownload(this, this.mtInfo.wsId, this.currentClip.clipId, this.currentClip.isCopied)
        let result = await getFileDownload(this, this.mtInfo.wsId, this.currentClip.clipId)

        if (result !== undefined && result !== null) {
          let link = document.createElement('a')
          let url = URL.createObjectURL(result)
          link.href = url
          link.download = `${title}.mp4`
          link.click()
          setTimeout(function () {
            // document.body.removeChild(link)
            URL.revokeObjectURL(url)
          }, 100)
          clearInterval(getPercent)
          this.downloadPercent = 100
        } else {
          clearInterval(getPercent)
          // notify(this, 'Error', this.$t('videoNotConvertedYet'), 'error')

          const content = {
            component: Toast,
            props: {
              msg: this.$t('videoNotConvertedYet'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
          this.$set(this, 'downloadPercent', 0)
        }
      } catch (err) {
        clearInterval(getPercent)
        // notify(this, 'Error', this.$t('general.error'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('general.error'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        this.$set(this, 'downloadPercent', 0)
      } finally {
        this.isDownloadLoading = false
      }
    },
    // 현재 수정중인 Clip 을 Store Data 에 저장한다
    focusTxtF() {
      this.$store.dispatch('setEditingClip', this.currentClip)
    },
    // 현재 수정중인 Clip 을 Store Data 에 저장한다
    blurTxtF() {
      this.setClipUpdate()
      this.$store.dispatch('setEditingClip', null)
    },
    autoUpdate() {
      if (this.$refs.titleTxtF !== undefined) this.$refs.titleTxtF.blur()
      if (this.$refs.noteTxtF !== undefined) this.$refs.noteTxtF.blur()
    },
    setLinks(text) {
      const Rexp =
        /(\b(https?|ftp|file):\/\/([-A-Z0-9+&@#%?=~_|!:,.;]*)([-A-Z0-9+&@#%?\\/=~_|!:,.;]*)[-A-Z0-9+&@#\\/%=~_|])/gi
      return text.replaceAll('\n', '</br>').replace(Rexp, "<a href='$1' target='_blank'>$1</a>")
    },
  },
  computed: {
    ...mapGetters(['isMtOrganizer', 'isWsOwner', 'isWsManager']),
    getDownloadPercent() {
      return localStorage.getItem('downloadPercent')
    },
    totalWatchedUser() {
      let userList = []
      if (this.currentClip) {
        if (this.currentClip.watchedUser && this.currentClip.watchedUser.length > 0) {
          userList = userList.concat(this.currentClip.watchedUser)
        }
        if (this.currentClip.anonymousUser && this.currentClip.anonymousUser.length > 0) {
          userList = userList.concat(this.currentClip.anonymousUser)
        }
      }
      return userList
    },

    ...mapState({
      currentClip: (state) => {
        return state.clip.currentClip
      },
      wsInfo() {
        return this.$store.getters.selectedWsInfo
      },
      mtInfo: (state) => {
        return state.auth.currentMt
      },
      userInfo: (state) => {
        return state.auth.userInfo && state.auth.userInfo !== null ? state.auth.userInfo : {}
      },
      storeSectionIndex: (state) => {
        return state.clip.sectionIndex
      },
      totalSectionList: (state) => {
        return state.clip.totalSectionList
      },
      clipIndex: (state) => {
        return state.clip.clipIndex
      },
      storeClipIndex: (state) => {
        return state.clip.clipIndex
      },
      editingClip: (state) => {
        return state.clip.editingClip
      },
      isMobile() {
        return isMobile()
      },
    }),
    isClipUploader() {
      return (
        this.currentClip !== undefined &&
        this.currentClip !== null &&
        this.currentClip.clipUploader &&
        this.currentClip.clipUploader !== null &&
        this.userInfo &&
        this.userInfo !== null &&
        this.currentClip.clipUploader.userId === this.userInfo.userId
      )
    },
    getLink() {
      return this.setLinks(this.currentClip.clipNote)
    },
    isLastClip() {
      return (
        this.clipList &&
        this.clipList !== null &&
        this.clipList.length > 0 &&
        this.$store.getters.isLastClip &&
        this.$store.getters.isLastClip !== null
      )
    },
    isFirstClip() {
      return (
        this.clipList &&
        this.clipList !== null &&
        this.clipList.length > 0 &&
        this.$store.getters.clipIndex === 0 &&
        this.sectionIndex === 0
      )
    },
    clipList() {
      return this.$store.getters.clipList
    },
    isDisableWatched() {
      return this.mtInfo.isPublic && (!this.userInfo || this.userInfo === null || !this.wsInfo || this.wsInfo === null)
    },
    isDisableDownload() {
      return (
        !this.userInfo ||
        this.userInfo === null ||
        Object.keys(this.userInfo).length == 0 ||
        (this.userInfo && this.userInfo.userStatus === 'G')
      )
    },
    isNotEmpty() {
      return this.clipList !== undefined && this.clipList !== null && this.clipList.length > 0
    },
  },
  watch: {
    currentClip(val) {
      this.autoUpdate()
      this.onClipChange(val)
      if (val) {
        if (this.memberList.length == 0) {
          this.getMember()
        } else {
          this.setList()
        }
      }
    },
    'currentClip.isWatched'(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        if (this.memberList.length == 0) {
          this.getMember()
        } else {
          this.setList()
        }
      }
    },
    'currentClip.customRecipientList'(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        if (this.memberList.length == 0) {
          this.getMember()
        } else {
          this.setList()
        }
      }
    },
    sectionIndex() {
      this.autoUpdate()
    },
  },
}
</script>
<style scoped>
.wrap-button {
  display: flex;
  justify-content: end;
  align-items: self-end;
  z-index: 6;
}
.container-button {
  display: flex;
  justify-content: end;
  align-items: self-end;
  z-index: 6;
}
.container-btn >>> .v-btn--disabled {
  opacity: 0.33 !important;
}
.container-btn >>> button:hover {
  background-color: rgb(33, 52, 59);
}
@media (max-width: 959px) {
  .container-btn .btn-control {
    background-color: transparent !important;
  }
}
.badge-watched {
  display: inline-block;
  position: absolute;
  width: auto;
  min-width: 15px;
  height: 15px;
  top: -10px;
  right: -5px;
  padding: 1.5px 1.5px 0 0;
  background-color: #ccc;
  box-shadow: 0 0 0 2px #161d21;
  /* outline: 2px solid #161d21; */
  color: #161d21;
  border-radius: 18px;
  font-size: 10px;
  font-weight: 600;
  text-align: center;
  vertical-align: middle;
  letter-spacing: -0.66px;
}
.v-tooltip {
  z-index: 200;
}
.v-tooltip__content {
  font-size: 12px !important;
  opacity: 1;
}
/* .v-btn {
  transition: all 0.3s;
  border: 1px solid transparent;
}
.v-btn:hover {
  border: 1px solid rgba(10, 14, 16, 1);
  background-color: rgb(33, 52, 59);
  transition: all 0.3s;
} */
.checkmark {
  width: 35px;
  height: 35px;
  position: absolute;
  right: 0;
  overflow: hidden;
}
.checkmark::before,
.checkmark::after {
  content: '';
  position: absolute;
  background-color: white;
  width: 0;
  height: 3px;
  transform-origin: left;
  animation-duration: 0.3s;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
  border-radius: 5px;
}
.checkmark::before {
  top: 16px;
  left: 12px;
  transform: rotate(45deg);
  animation-name: left;
  animation-delay: 0.8s;
}
.checkmark::after {
  top: 21px;
  left: 15px;
  transform: rotate(-45deg);
  animation-name: right;
  animation-delay: 1.1s;
}
@keyframes left {
  0% {
    width: 0;
  }
  100% {
    width: 5px;
  }
}
@keyframes right {
  0% {
    width: 0;
  }
  100% {
    width: 13px;
  }
}
.container-menu-comment {
  width: 200px;
  padding: 4px;
  border-radius: 5px;
  border: 1px solid #475e69;
}
.container-menu-comment >>> .row--dense > .col {
  padding: 4px !important;
}
.container-btn .btn-control {
  width: 35px;
  height: 35px;
  background-color: transparent;
  padding: 0 !important;
  min-width: 35px !important;
}
.container-menu-comment >>> button {
  background-color: transparent !important;
}
.container-menu-comment >>> button span {
  font-size: 13px;
  font-weight: 400;
}

.container-menu-comment >>> .btn-control {
  width: 192px;
  justify-content: start;
}
.container-menu-comment >>> button:hover {
  /* border: 1px solid #666; */
  background-color: #161d21 !important;
}
</style>
